import { AutocompleteOption } from 'redesign';
import { BusinessUnitsFilterBranchOffice } from './filter-business-units.types';
import { getDepartmentsFromSelectedBranchOffices } from '../business-units-with-company/get-business-units-with-company-options';

export const getBusinessUnitsOptions = (
  branchOffices: BusinessUnitsFilterBranchOffice[],
  selectedBranchOffices?: AutocompleteOption[]
) => {
  const options: Record<'branchOffices' | 'departments', AutocompleteOption[]> = {
    branchOffices: [],
    departments: [],
  };

  options.branchOffices = branchOffices.map((branchOffice) => {
    return {
      label: branchOffice.branchOfficeName,
      value: branchOffice.branchOfficeId,
    };
  });

  if (options.branchOffices.length === 0) {
    return options;
  }

  if (selectedBranchOffices && selectedBranchOffices?.length) {
    options.departments = getDepartmentsFromSelectedBranchOffices(
      branchOffices,
      selectedBranchOffices
    );
  }
  return options;
};
